document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }

  document.querySelectorAll('[data-quantity-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('[data-quantity]');
      const input = wrapper && wrapper.querySelector('input[type="number"]');
      if (!input) return;
      const step = Number(input.step) || 1;
      const current = Number(input.value) || 0;
      const min = Number(input.min) || 0;
      input.value = button.dataset.quantityButton === 'increase'
        ? current + step
        : Math.max(min, current - step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
